module.exports = __webpack_public_path__ + "img/egg-production.f42557f5.svg";